<template>
  <v-app-bar app color="primary" dark dense class="px-0">
    <v-spacer></v-spacer>
    <div v-if="loggedIn && menuitems.length > hideMenuItemsPoint" class="ma-0 pa-0">
      
      <v-btn
        text
        rounded
        v-for="item in sliceMenuItems(0, hideMenuItemsPoint)"
        :key="item.routename"
        :to="item.link"
        class="ma-0 pa-1"
      >
        
        <v-icon  class="mr-1">{{ item.icon }}</v-icon>
      </v-btn>
    </div>

    <div v-if="loggedIn && menuitems.length == hideMenuItemsPoint" class="ma-0 pa-0">
      
      <v-btn
        text
        rounded
        v-for="item in sliceMenuItems(0, hideMenuItemsPoint)"
        :key="item.routename"
        :to="item.link"
        class="ma-1 pa-3"
      >
        
        
        
        {{ item.title }}
      </v-btn>
    </div>

    <v-menu v-if="loggedIn && menuitems.length > hideMenuItemsPoint" left bottom z-index="100">
      <template v-slot:activator="{ on }">
        <v-btn icon v-on="on">
          <v-app-bar-nav-icon></v-app-bar-nav-icon>
        </v-btn>
      </template>

      <v-list dense>
        <v-list-item
          v-for="item in sliceMenuItems(hideMenuItemsPoint, menuitems.length)"
          :key="item.routename"
          :to="item.link"
        >
          <!--<v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>-->
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>

    <v-spacer></v-spacer>
    <v-menu v-if="loggedIn" z-index="100">
      <template v-slot:activator="{ on }">
        <v-btn outlined icon v-on="on" width="40" height="40">
          <PersonAvatar
            v-if="loggedIn"
            :avatar-filename="loggedUserAvatarFilename"
            avatar-height="36"
          ></PersonAvatar>
        </v-btn>
      </template>

      <v-list two-line subheader>
        <!--<v-subheader>Пользовательские настройки</v-subheader>-->
        <v-list-item :to="{ name: 'logout' }">
          <v-list-item-content>
            <v-list-item-title>Выйти</v-list-item-title>
            <v-list-item-subtitle>Версия {{ version }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-divider v-if="loggedUserIsAdmin"></v-divider>
      <AdminMenuList v-if="loggedUserIsAdmin"></AdminMenuList>
    </v-menu>
  </v-app-bar>
</template>

<script>
import { authComputed } from '@/store/helpers.js'
import PersonAvatar from '@/components/PersonAvatar.vue'
import AdminMenuList from '@/components/AdminMenuList.vue'

export default {
  components: {
    PersonAvatar,
    AdminMenuList
  },

  data() {
    return {
      menuitems: [
        {
          routename: 'new-articles',
          title: 'Новое',
          icon: 'mdi-new-box',
          link: { name: 'new-articles' }
        },
        {
          routename: 'home-blog',
          title: 'Дом',
          icon: 'mdi-home',
          link: { name: 'home-blog' }
        },

        {
          routename: 'journeys',
          title: 'Поездки',
          icon: 'mdi-earth',
          link: { name: 'journeys' }
        },
        {
          routename: 'immigration',
          title: 'Эмиграция',
          icon: 'mdi-airplane-takeoff',
          link: { name: 'immigration' }
        },
        {
          routename: 'countries',
          title: 'Страны',
          icon: 'mdi-flag-variant-outline',
          link: { name: 'countries' }
        },
        {
          routename: 'craft',
          title: 'Творчество',
          icon: 'mdi-format-paint',
          link: { name: 'craft' }
        },
        {
          routename: 'oldstories',
          title: 'История',
          icon: 'mdi-timer-sand-empty',
          link: { name: 'oldstories' }
        },
        {
          routename: 'piter',
          title: 'Питер',
          icon: 'mdi-timer-sand-empty',
          link: { name: 'piter' }
        }
      ]
    }
  },
  computed: {
    ...authComputed,
    version() {
      return this.$store.getters.getVersion.number
    },
    hideMenuItemsPoint() {
      if (this.$vuetify.breakpoint.name == 'xs') {
        return 4
      } else {
        return 8
      }
    }
  },

  methods: {
    sliceMenuItems: function(start, end) {
      return this.menuitems.slice(start, end)
    }
  }
}
</script>

<style>
.v-toolbar__content {
  padding-left: 0px !important;
}
</style>
